export default checkForEasterEggs = (q) ->
  if q.query?
    q = q.query
  if q.includes('gijsplore()')
    return 'gijsplore'
